import { render } from "./AccountDialog.vue?vue&type=template&id=15a2c71a&scoped=true"
import script from "./AccountDialog.vue?vue&type=script&lang=js"
export * from "./AccountDialog.vue?vue&type=script&lang=js"

import "./AccountDialog.vue?vue&type=style&index=0&id=15a2c71a&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a2c71a"]])

export default __exports__